import React, { useEffect } from "react";

const ImagePopup = ({ url, setShowImage }) => {
  const fileExtension = url && url.split(".").pop()?.toLowerCase();
  useEffect(() => {
    const body = document.body;

    const toggleOverlay = () => {
      body.style.overflow =
        body.style.overflow === "hidden" ? "auto" : "hidden";
    };
    toggleOverlay();
    return () => {
      toggleOverlay();
    };
  }, [setShowImage]);

  const renderMedia = () => {
    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={url}
          className="img-fluid post-img object-fit-contain"
          onClick={(e) => e.stopPropagation()}
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={url}
          className="img-fluid post-img object-fit-contain"
          onClick={(e) => e.stopPropagation()}
        />
      );
    } else {
      return (
        <video
          src={url}
          autoPlay
          muted
          loop
          controls
          className="img-fluid post-img object-fit-contain w-50 m-auto mt-3 d-block video-render"
          onClick={(e) => e.stopPropagation()}
        />
      );
    }
  };

  return (
    <div className="popup-overlay">
      <div
        className="popup-container cursor-pointer"
        onClick={() => {
          setShowImage("");
        }}
      >
        <h1>X</h1>
        {renderMedia()}
        {/* <img
          src={url}
          className="img-fluid post-img object-fit-contain"
          onClick={(e) => e.stopPropagation()}
        /> */}
      </div>
    </div>
  );
};

export default ImagePopup;
